import React from 'react';
import { toast } from 'react-toastify';
import axiosPrivate from '../../interceptor/axiosPrivate';

const SingleProductCard = ({ product, refetch }) => {
    const { name, description, price, quantity, min_order, img, _id } = product;
    const handleDeleteProduct = (id) => {
        axiosPrivate.delete(`https://smart-drilling.herokuapp.com/product/delete/${id}`).then(res => {
            toast.success("Product deleted successfully!");
            refetch();
        })
    }
    return (
        <div className="card lg:card-side bg-base-100 shadow-xl p-2">
            <figure><img src={img} alt="Album" /></figure>
            <div className="card-body">
                <h2 className="card-title">{name}</h2>
                <p>{description}</p>
                <div>
                    <p className='font-bold'>Price: ${price}</p>
                    <p><span className='text-green-600'>Stock Available:</span> {quantity} units</p>
                    <p>Minimum Order: {min_order} units</p>
                </div>
                <div className="card-actions justify-end">
                    <button onClick={() => handleDeleteProduct(_id)} className="btn btn-primary text-white">Delete Product</button>
                </div>
            </div>
        </div>
    );
};

export default SingleProductCard; 